import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import ScrollToTop from "./components/ScrollToTop";
import CanonicalTag from "./components/CanonicalTag";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import GTMLoader from "./components/GTMLoader";
import WhatsAppFloatingButton from "./components/WhatsAppFloatingButton";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import CompliancePage from "./pages/CompliancePage";
import WebCreationPage from "./pages/WebCreationPage";
import ContactPage from "./pages/ContactPage";
import LegalPage from "./pages/LegalPage";
import PrivacyPage from "./pages/PrivacyPage";
import CookiesPage from "./pages/CookiesPage";
import ControlPanelPage from "./pages/ControlPanelPage";
import DashPage from "./pages/DashPage";
import SuspendedAccountPage from "./pages/SuspendedAccountPage";

// Layout wrapper
const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <GTMLoader />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppFloatingButton />
      <CookieBanner />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <CanonicalTag />
        <LanguageProvider>
          <Routes>
            {/* Root redirects to Spanish (canonical version) */}
            <Route path="/" element={<Navigate to="/es" replace />} />
            
            {/* Spanish routes */}
            <Route path="/es" element={<Layout><HomePage /></Layout>} />
            <Route path="/es/servicios" element={<Layout><ServicesPage /></Layout>} />
            <Route path="/es/compliance" element={<Layout><CompliancePage /></Layout>} />
            <Route path="/es/cuenta-google-ads-suspendida" element={<Layout><SuspendedAccountPage /></Layout>} />
            <Route path="/es/creacion-web" element={<Layout><WebCreationPage /></Layout>} />
            <Route path="/es/contacto" element={<Layout><ContactPage /></Layout>} />
            <Route path="/es/legal" element={<Layout><LegalPage /></Layout>} />
            <Route path="/es/privacidad" element={<Layout><PrivacyPage /></Layout>} />
            <Route path="/es/cookies" element={<Layout><CookiesPage /></Layout>} />
            
            {/* French routes - proper French URLs */}
            <Route path="/fr" element={<Layout><HomePage /></Layout>} />
            <Route path="/fr/services" element={<Layout><ServicesPage /></Layout>} />
            <Route path="/fr/servicios" element={<Navigate to="/fr/services" replace />} />
            <Route path="/fr/compliance" element={<Layout><CompliancePage /></Layout>} />
            <Route path="/fr/compte-google-ads-suspendu" element={<Layout><SuspendedAccountPage /></Layout>} />
            <Route path="/fr/conformite" element={<Navigate to="/fr/compliance" replace />} />
            <Route path="/fr/creation-web" element={<Layout><WebCreationPage /></Layout>} />
            <Route path="/fr/creacion-web" element={<Navigate to="/fr/creation-web" replace />} />
            <Route path="/fr/contact" element={<Layout><ContactPage /></Layout>} />
            <Route path="/fr/contacto" element={<Navigate to="/fr/contact" replace />} />
            <Route path="/fr/legal" element={<Layout><LegalPage /></Layout>} />
            <Route path="/fr/mentions-legales" element={<Navigate to="/fr/legal" replace />} />
            <Route path="/fr/confidentialite" element={<Layout><PrivacyPage /></Layout>} />
            <Route path="/fr/privacidad" element={<Navigate to="/fr/confidentialite" replace />} />
            <Route path="/fr/cookies" element={<Layout><CookiesPage /></Layout>} />
            
            {/* English routes - proper English URLs */}
            <Route path="/en" element={<Layout><HomePage /></Layout>} />
            <Route path="/en/services" element={<Layout><ServicesPage /></Layout>} />
            <Route path="/en/servicios" element={<Navigate to="/en/services" replace />} />
            <Route path="/en/compliance" element={<Layout><CompliancePage /></Layout>} />
            <Route path="/en/google-ads-account-suspended" element={<Layout><SuspendedAccountPage /></Layout>} />
            <Route path="/en/web-creation" element={<Layout><WebCreationPage /></Layout>} />
            <Route path="/en/creacion-web" element={<Navigate to="/en/web-creation" replace />} />
            <Route path="/en/contact" element={<Layout><ContactPage /></Layout>} />
            <Route path="/en/contacto" element={<Navigate to="/en/contact" replace />} />
            <Route path="/en/legal" element={<Layout><LegalPage /></Layout>} />
            <Route path="/en/privacy" element={<Layout><PrivacyPage /></Layout>} />
            <Route path="/en/privacidad" element={<Navigate to="/en/privacy" replace />} />
            <Route path="/en/cookies" element={<Layout><CookiesPage /></Layout>} />
            
            {/* Hidden secured ops control panel - PIN protected, no Layout, noindex */}
            <Route path="/apagon" element={<ControlPanelPage />} />

            {/* Hidden dashboard — PEB network stats, PIN protected, noindex */}
            <Route path="/dash" element={<DashPage />} />

            {/* Fallback - redirect to Spanish */}
            <Route path="*" element={<Navigate to="/es" replace />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
